export default __webpack_public_path__ + "static/media/receipt.d99ddec6.png";